import { FiltersMapValue } from '../../../../shared/entities/filters/components/filterable-component/interfaces/FiltersMapValue';
import { searchFilterControls } from '../../../../shared/entities/filters/constants/filter-controls/searchFilterControls';
import { ResearchType } from '../../../../shared/entities/filters/enum/types/ResearchType';

export const researchFiltersControls: FiltersMapValue[] = [
  searchFilterControls[ResearchType.ReportProfile] as FiltersMapValue,
  searchFilterControls[ResearchType.ManagementQuestions] as FiltersMapValue,
  searchFilterControls[ResearchType.AnalystNote] as FiltersMapValue,
];
